export { default, CONTAINER_PADDING_TOP } from './Full';
// The props contract lives in shared/lib/types now — every brand's Layouts.Full is
// fed by the same builder. Re-exported here so existing importers keep working.
export type { FullLayoutProps } from '@v2/shared/lib/types';
// The builder's props plus the one thing this brand's Full takes that no builder
// produces: whether it draws the Container. See Full.tsx.
export type { FullProps } from './Full';
